import { FormInstance, Form } from 'antd';

export function useActiveFilters(form: FormInstance, fields: string[]) {
    const watchedValues =
        (Form.useWatch([], form) as Record<string, unknown> | undefined) || {};
    const values = fields.map((field) => watchedValues[field]);

    const isActive = (value: any) => {
        if (Array.isArray(value)) return value.length > 0;
        return value !== undefined && value !== null && value !== '';
    };

    return values.filter(isActive).length;
}
